import {ApiAxiosInstance, create} from "@/helpers/api";

export const order: ApiAxiosInstance = create();

export default order